export const TABLE_COLUMNS = {
  createdAt: {
    key: "createdAt",
    title: "Date of Upload",
    width: 170,
    sorter: true,
    dataIndex: "createdAt",
    dateFormat: "DD MMM'YY hh:mm A",
    defaultValue: "-",
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "descend",
    tooltipDateFormat: "relative",
    valueRenderingType: "timestamp",
  },
  uploadedFileName: {
    key: "uploadedFileName",
    title: "File Name",
    width: 200,
    sorter: true,
    dataIndex: "uploadedFileName",
    defaultValue: "-",
    valueRenderingType: "file_name_custom",
  },
  dataImportType: {
    key: "dataImportType",
    title: "Upload Type",
    width: 150,
    sorter: true,
    dataIndex: "dataImportType",
    defaultValue: "-",
    valueRenderingType: "upload_type_custom",
  },
  numTotalRecords: {
    key: "numTotalRecords",
    title: "Record Count",
    width: 130,
    sorter: true,
    dataIndex: "numTotalRecords",
    defaultValue: "-",
    valueRenderingType: "number",
  },
  status: {
    key: "status",
    title: "Status",
    width: 150,
    sorter: true,
    dataIndex: "status",
    defaultValue: "-",
    valueRenderingType: "status_custom",
  },
  uploadedFileSize: {
    key: "uploadedFileSize",
    title: "File Size",
    width: 120,
    sorter: true,
    dataIndex: "uploadedFileSize",
    defaultValue: "-",
    valueRenderingType: "file_size_custom",
  },
  createdByUser: {
    key: "createdByUser",
    title: "Uploaded By",
    width: 150,
    sorter: true,
    dataIndex: "createdByUser",
    defaultValue: "-",
    valueRenderingType: "text",
  },
  userRemarks: {
    key: "userRemarks",
    title: "Remarks",
    width: 150,
    sorter: true,
    dataIndex: "userRemarks",
    defaultValue: "-",
    valueRenderingType: "text",
  },
};

export const TABLE_COLUMN_ORDER = [
  "createdAt",
  "uploadedFileName",
  "dataImportType",
  "numTotalRecords",
  "status",
  "uploadedFileSize",
  "createdByUser",
  "userRemarks",
];
